/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Offset_DaysInputs */

const cs_field_offset_days = /** @type {(inputs: Field_Offset_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odsun (dny)`)
};

const en_field_offset_days = /** @type {(inputs: Field_Offset_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset (days)`)
};

/**
* | output |
* | --- |
* | "Offset (days)" |
*
* @param {Field_Offset_DaysInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_offset_days = /** @type {((inputs?: Field_Offset_DaysInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Offset_DaysInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_offset_days(inputs)
	return cs_field_offset_days(inputs)
});